import { HEADER_HEIGHT } from 'config/ui';

const mixins = {
  toolbar: {
    minHeight: HEADER_HEIGHT,
  },
};

export default mixins;
